const myBetsContentStyles = {
    root: {
        display: "flex",
        flexDirection: ["column", "row", "row"]
    }
};
const myBetsHeaderStyles = {
    root: {
        paddingTop: "$s3",
        paddingRight: 0,
        paddingBottom: ["16px", "24px", "24px"],
        paddingLeft: 0,
        fontWeight: 700,
        fontSize: "$s3",
        lineHeight: "28px",
        textTransform: "uppercase",
    }
};
const myBetsWrapperStyles = {
    root: {
        height: "100%",
        paddingTop: 0,
        paddingRight: ["$s2", "0", "0"],
        paddingBottom: 0,
        paddingLeft: ["$s2", "$s3", "$s3"],
        color: "$white",
        backgroundColor: "$black",
        fontFamily: "Saira Condensed, Open Sans, sans-serif",
    }
};
export { myBetsWrapperStyles, myBetsContentStyles, myBetsHeaderStyles, };
//# sourceMappingURL=_localVariants.js.map